import TextCell from 'components/TextCell';
import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function StateCell({ rowData: { state } }: CellProps) {
  return <TextCell text={state} />;
}
